import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import React, {
  ComponentProps,
  KeyboardEvent as ReactKeyboardEvent,
  ReactNode,
  useId,
  useRef,
} from 'react';
import { P } from './text';
import { Disclaimer, H5 } from './text';
import { Separator } from '../components/navigation/navigation.styled';
import { lightTheme } from './theme';
import { flexGapFallback } from './flexGapFallback';
import { X } from '../assets';
import { Tooltip } from 'react-tooltip';
// Direct file import (not the `../adminComponents` barrel) on purpose: this
// file defines `Box`, and the barrel re-exports `AdminEditor`, which runs
// `styled(Box)` at module-init. Going through the barrel here pulls AdminEditor
// into styles' own init before `Box` is defined below, producing the webpack
// TDZ error "Cannot access 'Box' before initialization".
import { TooltipIcon } from '../adminComponents/Tooltips/Tooltips';

export const PageWrapper = styled.div<PageWrapperProps>`
  @media (min-width: 3000px) {
    max-width: 1940px;
  }

  @media (min-width: 3500px) {
    max-width: 80%;
    ${({ home }) => !home && `padding-top: 300px;`}
  }

  width: 100%;
  padding: 0 100px;
  max-width: 1640px;
  margin: 0 auto;
  position: relative;
  padding-bottom: 150px;
  min-height: calc(100vh + 50px);

  ${({ centeredContent }) =>
    centeredContent &&
    `
   display: flex;
  align-items: center;
  `}
  ${({ home }) => !home && `padding-top: 150px;`}

 

  @media (max-width: 1000px) and (orientation: landscape) {
    padding: 0 30px;
    padding-bottom: 100px;
    ${({ home }) => !home && `padding-top: 100px;`}
  }

  @media (max-width: 800px) {
    padding: 0 30px;
    padding-bottom: 100px;
    ${({ home }) => !home && `padding-top: 100px;`}
  }
`;

export const WrapperCenterSimpler = styled.div<WrapperCenterSimplerProps>`
  width: 100%;
  padding: 75px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ gap }) => (gap ? gap : '100px')};

  @media (min-width: 3500px) {
    padding: 150px 0;
    gap: ${({ gapLG }) => (gapLG ? gapLG : '200px')};
  }

  @media (max-width: 1200px) {
    gap: 50px;
  }

  @media (max-width: 800px) {
    padding: 30px 0;
    gap: 50px;
    flex-direction: column;
    ${({ reverse }) => reverse && ' flex-direction: column-reverse;'}
  }
`;

export const WrapperCenterSimplerHome = styled.div<WrapperCenterSimplerHomeProps>`
  position: relative;
  padding: 75px 0;
  display: flex;
  align-items: center;
  /* gap: 50px; */
  min-height: 100vh;
  padding: 0;

  @media (max-width: 1200px) {
  }

  @media (max-width: 800px) {
    gap: 30px;
    flex-direction: column-reverse;
    justify-content: center;
  }

  @media (max-height: 700px) {
    padding-top: 50px;
  }
  @media (max-width: 1000px) and (orientation: landscape) {
    padding-top: 80px;
    flex-direction: row;
  }
`;

export const Div = styled(motion.div)<DivProps>`
  z-index: ${(props) => props.$zIndex};
  border: ${(props) => props.$border};
  ${({ $box }) =>
    $box &&
    `
   background: #ffffff;
  border: 1px solid #e3e3e3;
  box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
`}

  ${({ $hoverUnderline }) =>
    $hoverUnderline &&
    `
    :hover {
      text-decoration: underline !important;
    }
  `}

  ${({ $color }) => $color && `color: ${$color};`};

  ${({ $box, $boxNoShadow }) =>
    $box &&
    $boxNoShadow &&
    `
  box-shadow: none;
 
`}
  ${({ $box, $boxNoBorder }) =>
    $box &&
    $boxNoBorder &&
    `
  border: none;
`}
 transition: box-shadow .3s ease;

  ${({ $outlineBox, theme }) =>
    $outlineBox &&
    `
  border: 1px solid ${theme.lightGray};
  border-radius: 20px;
`}

  ${({ $background }) => $background && `background: ${$background};`};
  ${({ $borderRadius }) => $borderRadius && `border-radius: ${$borderRadius};`};

  margin: ${(props) => props.$m};
  margin-top: ${(props) => props.$mt}px;
  margin-bottom: ${(props) => props.$mb}px;
  margin-left: ${(props) => props.$ml}px;
  margin-right: ${(props) => props.$mr}px;
  width: ${(props) => props.$width};
  height: ${(props) => props.$height};
  overflow: ${(props) => props.$overflow};
  ${({ $maxWidth }) => $maxWidth && `max-width: ${$maxWidth}`};
  ${({ $minWidth }) => $minWidth && `min-width: ${$minWidth}`};
  ${({ $maxHeight }) => $maxHeight && `max-height: ${$maxHeight}`};
  ${({ $minHeight }) => $minHeight && `min-height: ${$minHeight}`};
  padding: ${(props) => props.$p};

  ${({ $inlineFlex }) => $inlineFlex && 'display: inline-flex'};
  ${({ $flex }) => $flex && 'display: flex'};
  ${({ $flexNone }) => $flexNone && 'flex: none'};
  ${({ $center }) => $center && 'align-items: center; justify-content:center;'};
  ${({ $between }) => $between && 'justify-content: space-between;'};
  ${({ $gap, $flex, $grid }) => ($flex || $grid) && $gap && `gap:${$gap}`};
  ${({ $pointer }) => $pointer && 'cursor: pointer'};
  ${({ $notAllowed }) => $notAllowed && 'cursor: not-allowed !important'};
  ${({ $relative }) => $relative && 'position: relative'};
  ${({ $absolute }) => $absolute && 'position: absolute'};
  ${({ $fixed }) => $fixed && 'position: fixed'};
  ${({ $alignCenter }) => $alignCenter && 'align-items: center'};
  ${({ $alignStart }) => $alignStart && 'align-items: start'};
  ${({ $alignEnd }) => $alignEnd && 'align-items: flex-end'};
  ${({ $alignStart }) => $alignStart && 'align-items: flex-start'};
  ${({ $justifyEnd }) => $justifyEnd && 'justify-content: flex-end'};
  ${({ $justifyCenter }) => $justifyCenter && 'justify-content: center'};
  ${({ $justifyAround }) => $justifyAround && 'justify-content: space-around'};
  ${({ $justifyEvenly }) => $justifyEvenly && 'justify-content: space-evenly'};
  ${({ $textAlignCenter }) => $textAlignCenter && 'text-align: center'};
  ${({ $textAlignRight }) => $textAlignRight && 'text-align: right'};
  ${({ $textAlignLeft }) => $textAlignLeft && 'text-align: left'};
  ${({ $wrap }) => $wrap && 'flex-wrap: wrap'};
  ${({ $borderBottom, theme }) =>
    $borderBottom && `border-bottom ${theme.borders.border1}`};
  ${({ $opacity }) => $opacity && `opacity: ${$opacity};`}

  ${({ $top }) => $top && `top: ${$top}`};
  ${({ $left }) => $left && `left: ${$left}`};
  ${({ $right }) => $right && `right: ${$right}`};
  ${({ $bottom }) => $bottom && `bottom: ${$bottom}`};
  ${({ $transform }) => $transform && `transform: ${$transform}`};
  ${({ $borderTop, theme }) =>
    $borderTop && `border-top ${theme.borders.border1}`};

  ${({ $borderLeft, theme }) =>
    $borderLeft && `border-left ${theme.borders.border1}`};

  ${({ $borderRight, theme }) =>
    $borderRight && `border-right ${theme.borders.border1}`};

  ${({ $borderColor }) => $borderColor && `border-color: ${$borderColor};`};

  ${({ $grid }) => $grid && 'display: grid'};
  ${({ $grid, $gridTemplateColumns }) =>
    $grid &&
    $gridTemplateColumns &&
    `grid-template-columns:${$gridTemplateColumns}`};

  ${({ $column }) => $column && 'flex-direction: column'};

  ${flexGapFallback}

  @media (min-width: 3500px) {
    height: ${(props) => props.$heightLG};
    width: ${(props) => props.$widthLG};
    ${({ $maxWidthLG }) => $maxWidthLG && `max-width: ${$maxWidthLG}`};
    padding: ${(props) => props.$pLG};
    max-width: ${(props) => props.$maxWidthLG};
    min-width: ${(props) => props.$minWidthLG};
    ${({ $gapLG }) => $gapLG && `gap: ${$gapLG}`};
    margin: ${(props) => props.$mLG};
    margin-top: ${(props) => props.$mtLG}px;
    margin-bottom: ${(props) => props.$mbLG}px;
    margin-left: ${(props) => props.$mlLG}px;
    margin-right: ${(props) => props.$mrLG}px;
  }

  @media (max-width: 1450px) {
    width: ${(props) => props.$widthMD};
    padding: ${(props) => props.$pMD};
    ${({ $gapMD }) => $gapMD && `gap: ${$gapMD}`};
    ${({ $columnMD }) => $columnMD && 'flex-direction: column'};
    ${({ $reverseMD }) => $reverseMD && 'flex-direction: column-reverse'};
  }

  @media (max-width: 1100px) {
    ${({ $columnTablet }) => $columnTablet && 'flex-direction: column'};
    ${({ $alignStartTablet }) =>
      $alignStartTablet && 'align-items: flex-start;'};
    ${({ $gapTablet }) => $gapTablet && `gap: ${$gapTablet}`};
    ${({ $widthTablet }) => $widthTablet && `width: ${$widthTablet}`};
  }

  @media (max-width: 800px) {
    ${({ $topSM }) => $topSM && `top: ${$topSM}`};
    ${({ $leftSM }) => $leftSM && `left: ${$leftSM}`};
    ${({ $rightSM }) => $rightSM && `right: ${$rightSM}`};
    ${({ $bottomSM }) => $bottomSM && `bottom: ${$bottomSM}`};
    height: auto;
    padding: ${(props) => props.$pSM};
    margin: ${(props) => props.$mSM};
    margin-top: ${(props) => props.$mtSM}px;
    margin-bottom: ${(props) => props.$mbSM}px;
    margin-left: ${(props) => props.$mlSM}px;
    margin-right: ${(props) => props.$mrSM}px;
    width: ${(props) => props.$widthSM};
    min-width: ${(props) => props.$minWidthSM};
    ${({ $heightSM }) => $heightSM && `height: ${$heightSM}`};
    ${({ $maxHeightSM }) => $maxHeightSM && `max-height: ${$maxHeightSM}`};
    ${({ $minHeightSM }) => $minHeightSM && `min-height: ${$minHeightSM}`};
    max-width: ${(props) => props.$maxWidthSM};
    ${({ $flexSM }) => $flexSM && 'display: flex'};
    ${({ $centerSM }) =>
      $centerSM && 'align-items: center; justify-content:center;'};
    ${({ $startSM }) => $startSM && 'align-items: start;'};
    ${({ $alignStartSM }) => $alignStartSM && 'align-items: flex-start;'};
    ${({ $alignEndSM }) => $alignEndSM && 'align-items: flex-end;'};
    ${({ $gapSM }) => $gapSM && `gap: ${$gapSM}`};
    ${({ $columnSM }) => $columnSM && 'flex-direction: column'};
    ${({ $reverseSM }) => $reverseSM && 'flex-direction: column-reverse'};
    ${({ $wrapSM }) => $wrapSM && 'flex-wrap: wrap'};
    ${({ $betweenSM }) => $betweenSM && 'justify-content: space-between;'};
    ${({ $alignCenterSM }) => $alignCenterSM && 'align-items: center;'};
    ${({ $justifyEndSM }) => $justifyEndSM && 'justify-content: flex-end;'};
    ${({ $rowSM }) => $rowSM && 'flex-direction: row;'};
    ${({ $grid, $gridTemplateColumnsSM }) =>
      $grid &&
      $gridTemplateColumnsSM &&
      `grid-template-columns:${$gridTemplateColumnsSM}`};

    ${({ $box }) =>
      $box &&
      `
  border-radius: 16px;
`}
  }

  ${({ $desktop }) =>
    $desktop &&
    `
    @media (max-width: 800px) {
    display: none;
  }

  `};

  ${({ $tabletUp }) =>
    $tabletUp &&
    `
    @media (max-width: 1200px) {
    display: none;
  }
  
  `};

  ${({ $tablet }) =>
    $tablet &&
    `
    @media (min-width: 1201px) {
    display: none;
  }
  
  `};

  ${({ $mobile }) =>
    $mobile &&
    `
    @media (min-width: 800px) {
    display: none;
  }
  
  `};
`;

export const CollapsibleComponent = styled.div<{
  expanded: boolean;
  elementHeight?: number;
  marginTop?: string;
}>`
  opacity: ${(props) => (props.expanded ? '1' : '0')};
  visibility: ${(props) => (props.expanded ? 'visible' : 'hidden')};
  max-height: ${({ expanded, elementHeight }) =>
    expanded ? `${elementHeight}px` : '0px'};
  margin-top: ${(props) => (props.expanded ? props.marginTop || '0' : '0px')};
  /* Collapsed, the box is 0px tall but its content still hangs out below it,
     invisible, and stretches the scroll area into a blank gap. So it clips
     while closed and while opening, and lets go once open (300ms), where the
     shadows and dropdowns inside must not be cut off. Without
     allow-discrete support it lets go at once, which only shows mid-open. */
  overflow: ${(props) => (props.expanded ? 'visible' : 'hidden')};
  transition: all 300ms,
    overflow 0s ${(props) => (props.expanded ? '300ms' : '0s')};
  transition-behavior: allow-discrete;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

export const Break = styled.div<{ $desktop?: boolean; $mobile?: boolean }>`
  ${({ $desktop }) =>
    $desktop &&
    `
    @media (max-width: 800px) {
    display: none;
  }
  `}
  ${({ $mobile }) =>
    $mobile &&
    `
    @media (min-width: 800px) {
    display: none;
  }
  `}
`;
export const ScrollableModalDiv = styled.div<ScrollableModalDivProps>`
  overflow-y: scroll;
  max-height: 220px;

  margin: 0 -32px;
  padding: 0 32px 0px 32px;

  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;

  @media (max-width: 800px) {
    margin: 0 -24px;
    padding: 0 24px 24px 24px;
    max-height: 150px;
  }
`;

export const MotionDiv = styled(motion.div)``;

export const Img = styled.img<ImgProps>`
  margin: ${(props) => props.$m};
  margin-top: ${(props) => props.$mt}px;
  margin-bottom: ${(props) => props.$mb}px;
  margin-left: ${(props) => props.$ml}px;
  margin-right: ${(props) => props.$mr}px;
  height: ${(props) => props.$height};
  width: ${(props) => props.$width};
  max-width: ${(props) => props.$maxWidth};
  max-height: ${(props) => props.$maxHeight};
  border: ${(props) => props.$border};
  border-radius: ${(props) => props.$borderRadius};
  min-width: ${(props) => props.$width};
  min-height: ${(props) => props.$height};
  vertical-align: ${(props) => props.$verticalAlign};
  @media (max-width: 800px) {
    margin: ${(props) => props.$mSM};
    margin-top: ${(props) => props.$mtSM}px;
    margin-bottom: ${(props) => props.$mbSM}px;
    margin-left: ${(props) => props.$mlSM}px;
    margin-right: ${(props) => props.$mrSM}px;
    width: ${(props) => props.$widthSM};
    height: ${(props) => props.$heightSM};
    max-width: ${(props) => props.$maxWidthSM};
    max-height: ${(props) => props.$maxHeightSM};
    min-width: ${(props) => props.$widthSM};
    min-height: ${(props) => props.$heightSM};
    vertical-align: ${(props) => props.$verticalAlign};
  }
`;

export const SplashScreen = styled(motion.div)`
  z-index: 999999999;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.primary};
`;

export const Icon = styled.div<IconProps>`
  margin: ${(props) => props.$m};
  display: ${({ display }) => (display ? display : 'flex')};
  ${({ $maxSize }) =>
    $maxSize && `max-width: ${$maxSize}px; max-height: ${$maxSize}px;`};

  align-items: center;

  svg {
    ${({ $verticalAlignBottom }) =>
      $verticalAlignBottom && `vertical-align: middle;`};
  }

  ${({ $shadow, theme }) =>
    $shadow &&
    `
    border: 1px solid #e3e3e3;
    box-shadow:  ${theme.shadows.shadow2};
    border-radius: 50%;
  `}

  ${({ $rotateAnimation }) =>
    $rotateAnimation &&
    `
      @keyframes rotate {
    0% {
      transform:   rotate(0deg);
    }
    100% {
      transform:  rotate(360deg);
    }
  }
     animation: rotate 0.5s linear infinite;
  `}

  ${({ $background, $backgroundSize }) =>
    $background &&
    `
      background-color: ${$background};
      width: ${$backgroundSize || 34}px;
      height: ${$backgroundSize || 34}px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: none;
  `}

  ${({ $borderColor }) => $borderColor && `border: 1px solid ${$borderColor};`}

  ${({ $rotate }) =>
    $rotate && `rotate: ${$rotate}; transition: rotate 0.3s ease;`}

      ${({ $opacity }) => $opacity && `opacity: ${$opacity};`}

  ${({ $pointer }) => $pointer && `cursor: pointer;`}
  ${({ color }) =>
    color &&
    `
      svg {
        path {
          fill: ${color};
        }
      }
  `}

  ${({ hoverColor, theme }) =>
    hoverColor &&
    `
      svg {
        path {
          transition: ${theme.transitions.ease300ms};
        }
        :hover {
          path {
            fill: ${hoverColor};
          }
        }
      }
  `}

${({ hoverBackgroundColor, theme }) =>
    hoverBackgroundColor &&
    `
    
      transition: ${theme.transitions.ease300ms};
      :hover {
        background-color: ${hoverBackgroundColor};
      }
  `}

 

  ${({ $size }) => `

  svg {
    width: ${$size}px;
    height: ${$size}px;

  }

  `}

${({ $disabled }) => $disabled && `opacity: 0.5; cursor: not-allowed;`}


${({ $backgroundSize }) => `
  width: ${$backgroundSize}px;
  height: ${$backgroundSize}px;
`}

  @media (max-width: 800px) {
    ${({ $sizeSM }) => `

      svg {
        width: ${$sizeSM}px;
        height: ${$sizeSM}px;

      }
    
    `}
  }

  @media (min-width: 3500px) {
    svg {
      width: 48px;
      height: 48px;
    }
  }
`;

export const IconSpan = styled.span<IconProps>`
  margin: ${(props) => props.$m};
  display: ${({ display }) => (display ? display : 'flex')};
  ${({ $maxSize }) =>
    $maxSize && `max-width: ${$maxSize}px; max-height: ${$maxSize}px;`};

  align-items: center;

  svg {
    ${({ $verticalAlignBottom }) =>
      $verticalAlignBottom && `vertical-align: middle;`};
  }

  ${({ $shadow, theme }) =>
    $shadow &&
    `
    border: 1px solid #e3e3e3;
    box-shadow:  ${theme.shadows.shadow2};
    border-radius: 50%;
  `}

  ${({ $rotateAnimation }) =>
    $rotateAnimation &&
    `
      @keyframes rotate {
    0% {
      transform:   rotate(0deg);
    }
    100% {
      transform:  rotate(360deg);
    }
  }
     animation: rotate 0.5s linear infinite;
  `}

  ${({ $background, $backgroundSize }) =>
    $background &&
    `
      background-color: ${$background};
      width: ${$backgroundSize || 34}px;
      height: ${$backgroundSize || 34}px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: none;
  `}

  ${({ $rotate }) =>
    $rotate && `rotate: ${$rotate}; transition: rotate 0.3s ease;`}

      ${({ $opacity }) => $opacity && `opacity: ${$opacity};`}

  ${({ $pointer }) => $pointer && `cursor: pointer;`}
  ${({ color }) =>
    color &&
    `
      svg {
        path {
          fill: ${color};
        }
      }
  `}

  ${({ hoverColor, theme }) =>
    hoverColor &&
    `
      svg {
        path {
          transition: ${theme.transitions.ease300ms};
        }
        :hover {
          path {
            fill: ${hoverColor};
          }
        }
      }
  `}

  ${({ $size }) => `

  svg {
    width: ${$size}px;
    height: ${$size}px;

  }

  `}

  ${({ $backgroundSize }) => `
    width: ${$backgroundSize}px;
    height: ${$backgroundSize}px;
  `}

  @media (max-width: 800px) {
    ${({ $sizeSM }) => `

      svg {
        width: ${$sizeSM}px;
        height: ${$sizeSM}px;

      }
    
    `}
    ${({ $backgroundSizeSM }) => `
    width: ${$backgroundSizeSM}px;
    height: ${$backgroundSizeSM}px;
  `}
  }

  @media (min-width: 3500px) {
    svg {
      width: 48px;
      height: 48px;
    }
  }
`;

export const SvgInlineWrapper = styled.span`
  svg {
    vertical-align: middle;
  }
`;

export const Calculator = styled.div`
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid #e3e3e3;
  box-shadow: ${({ theme }) => theme.shadows.shadow1};
  gap: 24px;
  margin-bottom: 50px;

  @media (max-width: 800px) {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }
`;

export const CalculatorBottom = styled.div`
  background: ${({ theme }) => theme.green};
  width: 100%;
  padding: 15px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;

  @media (max-width: 800px) {
    flex-direction: column;
    gap: 10px;
  }
`;

export const StripLeft = styled.div`
  width: 40px;
  height: 400px;
  border: 2px solid ${({ theme }) => theme.primary};
  border-radius: 20px 0 0 20px;
  border-right: 0;

  @media (min-width: 3500px) {
    width: 80px;
    height: 800px;
  }

  @media (max-width: 1000px) {
    display: none;
  }
`;

export const StripRight = styled.div`
  width: 40px;
  height: 400px;
  border: 2px solid ${({ theme }) => theme.primary};
  border-radius: 0 20px 20px 0;
  border-left: 0;

  @media (min-width: 3500px) {
    width: 80px;
    height: 800px;
  }

  @media (max-width: 1000px) {
    display: none;
  }
`;

export const ContentStyled = styled.div`
  width: 100%;
  padding: 0 50px 50px 50px;
  overflow: hidden;
  min-height: 100vh;
  -webkit-overflow-scrolling: touch;

  /*
   * AdminLayout renders this as <main id="main-content" tabIndex={-1}>
   * so the "Skip to main content" link can move focus here. The browser
   * paints its default focus ring when that happens — suppress it,
   * because the user already intentionally jumped here and the outline
   * around the whole page is just noise. We keep outlines on actual
   * interactive children (buttons, links) untouched.
   */
  &:focus {
    outline: none;
  }

  @media (max-width: 800px) {
    padding: 0 16px 40px 16px;
  }
`;

export const HeaderIconWrapperStyled = styled.div<{
  $opened?: boolean;
  $disabled?: boolean;
  $marker?: boolean;
}>`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  border: 1px solid #e3e3e3;
  box-shadow: ${({ theme }) => theme.shadows.shadow2};

  border-radius: 50%;
  position: absolute;
  cursor: pointer;

  svg {
    display: block;
  }

  ${({ $opened }) => $opened && `z-index: 10;`}
  ${({ $disabled }) => $disabled && `opacity: 0.5;`}

  @media (max-width: 800px) {
    width: 40px;
    height: 40px;
  }
  ${({ $marker, theme, $opened }) =>
    $marker &&
    `
    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      width: 10px;
      height: 10px;
      background-color: ${theme.primary};
      border-radius: 50%;
    }
  `}
`;

export const HeaderIconWrapper = ({
  children,
  onClick,
  $opened,
  $disabled,
  $marker,
  ariaLabel,
  role = 'button',
  tabIndex = 0,
  onKeyDown,
  ...rest
}: React.HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode;
  onClick?: () => void;
  $opened?: boolean;
  $disabled?: boolean;
  $marker?: boolean;
  /** Names the control for screen readers - the disc holds an icon alone. */
  ariaLabel?: string;
}) => {
  // a11y: defaults make the wrapper behave like a button for keyboard
  // users — Tab can reach it, Enter/Space activate it. Callers that
  // open a dropdown should additionally pass `aria-haspopup="menu"`,
  // `aria-expanded` and `aria-label` (see AdminOptionsDropdown,
  // AdminRolePicker for examples). Callers can opt out with role={undefined}.
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    onKeyDown?.(event);
    if (event.defaultPrevented) return;
    if (role === 'button' && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      onClick?.();
    }
  };

  return (
    <Div
      $relative
      $width="40px"
      $height="40px"
      $widthSM="40px"
      $heightSM="40px"
    >
      <HeaderIconWrapperStyled
        onClick={onClick}
        aria-label={ariaLabel}
        $opened={$opened}
        $disabled={$disabled}
        $marker={$marker}
        role={role}
        tabIndex={$disabled ? -1 : tabIndex}
        onKeyDown={handleKeyDown}
        {...rest}
      >
        {children}
      </HeaderIconWrapperStyled>
    </Div>
  );
};

export const IconButtonStyled = styled.div<{
  $size?: string | number;
  $color?: string;
}>`
  width: ${({ $size }) => ($size ? $size : '40px')};
  height: ${({ $size }) => ($size ? $size : '40px')};
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ theme, $color }) => ($color ? $color : theme.white)};
  border-radius: 50%;
  cursor: pointer;
  flex: none;
`;

export const OverlayTransparent = styled(motion.div)`
  /* background-color: ${({ theme }) => theme.darkGray}4D; */
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
`;

export const Overlay = styled(motion.div)`
  background-color: ${({ theme }) => theme.darkGray}4D;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
`;

export const overlayAnimationVariant = {
  initial: {
    opacity: 0,
    transition: {
      type: 'ease',
      duration: 0.1,
    },
  },
  animate: {
    opacity: 1,
  },

  exit: {
    opacity: 0,
    transition: {
      type: 'ease',
      duration: 0.1,
    },
  },
};

export const ModalIconStyle = styled.div`
  width: 100px;
  height: 100px;
  background-color: ${({ theme }) => theme.primary};
  border-radius: 50%;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const UnderlineHoverLink = styled(Link)`
  :hover {
    text-decoration: underline;
  }
`;

export const AbsoluteAddressDropdown = styled(Div)`
  position: absolute;
  top: 76px;
  left: 0;
  right: 0;
  background-color: ${({ theme }) => theme.white};
  z-index: 200;
  max-height: 200px;
  overflow: auto;

  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;

  > div {
    :hover {
      color: ${({ theme }) => theme.primary};
      text-decoration: underline;
    }
  }
`;

export const NotificationAlertWrapper = styled.div<{
  $show: boolean;
}>`
  position: relative;

  &::after {
    display: ${({ $show }) => ($show ? 'block' : 'none')};
    content: '';
    position: absolute;
    right: 2px;
    top: 2px;
    width: 12px;
    height: 12px;
    background-color: ${({ theme }) => theme.primary};
    border-radius: 50%;
  }
`;

export const AdminInputPlaceholderStyled = styled.div<{
  $icon?: boolean;
  value?: any;
  $shadowDesign?: boolean;
  $textCenter?: boolean;
}>`
  position: relative;
  width: 100%;
  cursor: ${({ onClick }) => onClick && 'pointer'};
  display: inline-flex;
  align-items: center;

  justify-content: ${({ $icon }) => ($icon ? 'space-between' : 'center')};

  border: 1px solid ${({ theme }) => theme.darkGray}80;
  border-radius: 200px;
  font-size: ${({ theme }) => theme.input.fontSize};
  line-height: 18px;
  padding: 0 24px;
  display: flex;
  align-items: center;
  height: ${({ theme }) => theme.input.height};
  -moz-appearance: none; /* Firefox */
  -webkit-appearance: none; /* Safari and Chrome */
  appearance: none;
  background: none;

  ${({ value, theme }) =>
    !value ? `color: ${theme.darkGray}E6;` : `color: ${theme.darkGray};`}

  ${({ $shadowDesign, theme }) =>
    $shadowDesign &&
    `
  background: ${theme.white};
  border: 1px solid #e3e3e3;
  box-shadow: ${theme.shadows.shadow1};
  `}

  ${({ $textCenter }) => $textCenter && `text-align: center`};

  :focus {
    outline: none !important;
    border: 1px solid ${({ theme }) => theme.primary};
  }

  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
`;

const IconStyled = styled.div<{ disabled?: boolean }>`
  position: absolute;
  right: 16px;
  left: auto;
  top: 50%;
  transform: translate(0, -50%);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    vertical-align: middle;
  }
  /* height: 16px; */
  ${({ disabled }) => disabled && `opacity: 0.5;`}
  pointer-events: none;
`;

const InputLabelTooltip = ({ tooltip }: { tooltip: string }) => (
  <TooltipIcon tooltip={tooltip} color={lightTheme.darkGray} />
);

export const Label = ({
  label,
  tooltip,
  $textCenter,
  htmlFor,
}: {
  label: string;
  tooltip?: string;
  $textCenter?: boolean;
  /**
   * `id` of the input this label belongs to. When set, the rendered
   * element is a real `<label htmlFor>` — clicks focus the input and
   * assistive tech announces them together. AdminInput auto-generates
   * an id and passes it here, so this is rarely supplied directly.
   */
  htmlFor?: string;
}) => {
  return (
    <P
      as={htmlFor ? 'label' : 'p'}
      htmlFor={htmlFor}
      $mb="8"
      $ml="24"
      $mr="24"
      $bold
      $color={lightTheme.darkGray}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: $textCenter ? 'center' : 'flex-start',
        gap: '4px',
      }}
    >
      {label} {tooltip && <InputLabelTooltip tooltip={tooltip} />}
    </P>
  );
};

const IconStyledClear = styled.div<{ disabled?: boolean }>`
  position: absolute;
  right: 18px;
  left: auto;
  top: 50%;
  transform: translate(0, -50%);
  z-index: 1;
  height: 12px;
  ${({ disabled }) => disabled && `opacity: 0.5;`}
  cursor: pointer;
`;

export const AdminInputPlaceholder = ({
  label,
  placeholder,
  value,
  $textCenter,
  onClick,
  $shadowDesign,
  tooltip,
  Icn,
  tooltipWidth,
  tooltipWidthSM,
  onClickClear,
  'aria-haspopup': ariaHaspopup,
  'aria-expanded': ariaExpanded,
  'aria-controls': ariaControls,
  'aria-label': ariaLabel,
}: {
  label?: string;
  placeholder?: string;
  value?: string | null;
  $textCenter?: boolean;
  onClick?: () => void;
  $shadowDesign?: boolean;
  Icn?: any;
  tooltip?: string;
  tooltipWidth?: string;
  tooltipWidthSM?: string;
  onClickClear?: (e: React.MouseEvent<HTMLDivElement>) => void;
  /**
   * a11y forwards. Pass `aria-haspopup="dialog" | "listbox" | "menu"`
   * etc. plus `aria-expanded` from the caller so screen readers
   * announce what the trigger opens and its open/closed state.
   * AdminInputPlaceholder is a generic clickable; only the caller
   * knows whether opening it shows a modal, listbox, or menu.
   */
  'aria-haspopup'?: React.AriaAttributes['aria-haspopup'];
  'aria-expanded'?: React.AriaAttributes['aria-expanded'];
  'aria-controls'?: string;
  'aria-label'?: string;
}) => {
  // a11y: link the visible <Label> to the placeholder via htmlFor/id.
  // Click on the label focuses the placeholder; screen readers
  // announce them together. Also gives us a fallback labelledby id
  // for cases where there's no aria-label override.
  const idForLabel = useId();

  return (
    <Div $relative>
      {label && (
        <Label
          label={label}
          tooltip={tooltip}
          $textCenter={$textCenter}
          htmlFor={idForLabel}
        />
      )}
      <AdminInputPlaceholderStyled
        id={idForLabel}
        $textCenter={$textCenter}
        onClick={onClick}
        value={value}
        $shadowDesign={$shadowDesign}
        $icon={Icn}
        // a11y: was a plain <div onClick>. role=button + tabIndex=0
        // makes it Tab-reachable; the onKeyDown converts Enter/Space →
        // click. Forward aria-* for callers that open dropdowns/dialogs.
        role="button"
        tabIndex={0}
        aria-haspopup={ariaHaspopup}
        aria-expanded={ariaExpanded}
        aria-controls={ariaControls}
        aria-label={ariaLabel ?? (!label ? placeholder : undefined)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick?.();
          }
        }}
      >
        <Div $width="100%">{value ?? placeholder}</Div>
        {Icn && (!onClickClear || !value) && (
          <IconStyled>
            <Icn />
          </IconStyled>
        )}
        {onClickClear && value && (
          <IconStyledClear
            onClick={(e) => {
              e.stopPropagation();
              onClickClear?.(e);
            }}
          >
            <Icon $pointer $size="12">
              <X fill={lightTheme.darkGray} />
            </Icon>
          </IconStyledClear>
        )}
      </AdminInputPlaceholderStyled>

      {tooltip && (
        <>
          <Div $desktop>
            <Tooltip
              clickable
              id={tooltip}
              style={{
                maxWidth: tooltipWidth ?? '500px',
                background: lightTheme.white,
                color: lightTheme.darkGray,
                padding: 16,
                borderRadius: 20,
                boxShadow: '0px 10px 15px rgba(0, 0, 0, 0.05)',
                zIndex: '1',
              }}
              border="1px solid #e3e3e3"
            />
          </Div>
          <Div $mobile>
            <Tooltip
              id={tooltip}
              style={{
                maxWidth: tooltipWidthSM ?? '95%',
                background: lightTheme.white,
                color: lightTheme.darkGray,
                padding: 16,
                borderRadius: 20,
                boxShadow: '0px 10px 15px rgba(0, 0, 0, 0.05)',
                zIndex: '1',
              }}
              border="1px solid #e3e3e3"
            />
          </Div>
        </>
      )}
    </Div>
  );
};

interface PageWrapperProps {
  home?: boolean;
  centeredContent?: boolean;
}

interface WrapperCenterSimplerProps {
  gap?: string;
  gapLG?: string;
  reverse?: boolean;
}

interface WrapperCenterSimplerHomeProps {
  reverse?: boolean;
}

interface ScrollableModalDivProps {
  children?: React.ReactNode;
}

interface DivProps {
  $zIndex?: string | number;
  $box?: boolean;
  $outlineBox?: boolean;
  $background?: string | null | false;
  $borderColor?: string | null | undefined | false;
  $borderRadius?: string;
  $m?: string;
  $mt?: number | string;
  $mb?: number | string;
  $ml?: number | string;
  $mr?: number | string;
  $width?: string;
  $height?: string;
  $maxWidth?: string;
  $minWidth?: string;
  $maxHeight?: string;
  $minHeight?: string;
  $maxHeightSM?: string;
  $minHeightSM?: string;
  $p?: string;
  $inlineFlex?: boolean;
  $flex?: boolean;
  $flexNone?: boolean;
  $center?: boolean;
  $between?: boolean;
  $betweenSM?: boolean;
  $alignCenterSM?: boolean;
  $gap?: string;
  $pointer?: boolean;
  $relative?: boolean;
  $absolute?: boolean;
  $fixed?: boolean;
  $alignCenter?: boolean;
  $alignStart?: boolean;
  $alignEnd?: boolean;
  $justifyEnd?: boolean;
  $justifyEndSM?: boolean;
  $justifyCenter?: boolean;
  $justifyAround?: boolean;
  $justifyEvenly?: boolean;
  $textAlignCenter?: boolean;
  $textAlignRight?: boolean;
  $textAlignLeft?: boolean;
  $wrap?: boolean;
  $borderBottom?: boolean;
  $borderTop?: boolean;
  $borderLeft?: boolean;
  $borderRight?: boolean;
  $grid?: boolean;
  $gridTemplateColumns?: string;
  $column?: boolean;
  $heightLG?: string;
  $widthLG?: string;
  $maxWidthLG?: string;
  $pLG?: string;
  $minWidthLG?: string;
  $gapLG?: string;
  $mLG?: string;
  $mtLG?: number;
  $mbLG?: number;
  $mlLG?: number;
  $mrLG?: number;
  $widthMD?: string;
  $pMD?: string;
  $gapMD?: string;
  $columnMD?: boolean;
  $reverseMD?: boolean;
  $pSM?: string;
  $mSM?: string;
  $mtSM?: number | string;
  $mbSM?: number | string;
  $mlSM?: number | string;
  $mrSM?: number | string;
  $widthSM?: string;
  $minWidthSM?: string;
  $maxWidthSM?: string;
  $heightSM?: string;
  $flexSM?: boolean;
  $centerSM?: boolean;
  $alignStartSM?: boolean;
  $alignEndSM?: boolean;
  $gapSM?: string;
  $columnSM?: boolean;
  $reverseSM?: boolean;
  $wrapSM?: boolean;
  $desktop?: boolean;
  $mobile?: boolean;
  $tablet?: boolean;
  $tabletUp?: boolean;
  $boxNoShadow?: boolean;
  $boxNoBorder?: boolean;
  $gridTemplateColumnsSM?: string;
  $startSM?: boolean;
  $overflow?: string;
  $top?: string;
  $left?: string;
  $right?: string;
  $bottom?: string;
  $topSM?: string;
  $leftSM?: string;
  $rightSM?: string;
  $bottomSM?: string;
  $transform?: string;
  $boxPadding?: boolean;
  $columnTablet?: boolean;
  $alignStartTablet?: boolean;
  $gapTablet?: string;
  $widthTablet?: string;
  $hoverUnderline?: boolean;
  $color?: string;
  $opacity?: string;
  $notAllowed?: boolean;
  $border?: string | null | undefined | false;
  $rowSM?: boolean;
}

interface ImgProps {
  $m?: string;
  $mt?: number | string;
  $mb?: number | string;
  $ml?: number | string;
  $mr?: number | string;
  $height?: string;
  $width?: string;
  $maxWidth?: string;
  $maxHeight?: string;
  $border?: string;
  $borderRadius?: string;
  $mSM?: string;
  $mtSM?: number | string;
  $mbSM?: number | string;
  $mlSM?: number | string;
  $mrSM?: number | string;
  $widthSM?: string;
  $heightSM?: string;
  $maxWidthSM?: string;
  $maxHeightSM?: string;
  $verticalAlign?: string;
}

interface IconProps {
  $disabled?: boolean;
  $maxSize?: number;
  $m?: string;
  display?: string;
  $verticalAlignBottom?: boolean;
  $shadow?: boolean;
  $background?: string;
  $rotate?: string;
  $pointer?: boolean;
  color?: string;
  hoverColor?: string;
  hoverBackgroundColor?: string;
  $size?: number | string | boolean;
  $sizeSM?: number | string;
  $opacity?: string;
  $color?: string;
  $borderColor?: string;
  $overflow?: string;
  $startSM?: boolean;
  $backgroundSize?: number | string;
  $backgroundSizeSM?: number | string;
  $rotateAnimation?: boolean;
  $p?: string;
}

interface LinkStyledProps {
  $noUnderline?: boolean;
}

const TabStyled = styled.div<{
  selected?: boolean;
  $big?: boolean;
  $minWidthAuto?: boolean;
  $minWidthAutoMD?: boolean;
  $minWidthAutoSM?: boolean;
  $width?: string;
  $widthSM?: string;
  $small?: boolean;
  $padding?: string;
  $paddingSmall?: string;
  $smallSM?: boolean;
}>`
  text-align: center;
  min-width: 200px;
  width: ${({ $width }) => $width && $width};
  background-color: ${({ selected, theme }) =>
    selected ? theme.white : 'none'};
  border: ${({ selected, theme }) =>
    selected ? `1px solid ${theme.white}` : `1px solid ${theme.lightGray}`};
  box-shadow: ${({ selected, theme }) =>
    selected ? theme.shadows.shadow1 : 'none'};
  color: ${({ selected, theme }) =>
    selected ? theme.primary : theme.darkGray};
  font-size: ${({ theme }) => theme.input.fontSize};

  height: ${({ theme }) => theme.input.height};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 200px;
  cursor: pointer;
  /*
   * Explicit transition list — NOT the "all" shorthand. With "all",
   * the focus outline width/offset would animate from 0 to its final
   * value on every focus, which reads as a chunky flash before
   * settling. Only transition the visual state properties (background,
   * border, color, shadow); leave outline to appear/disappear
   * instantly.
   */
  transition: background-color 0.3s ease, border-color 0.3s ease,
    color 0.3s ease, box-shadow 0.3s ease;
  flex: none;
  padding: 0 16px;
  ${({ $padding }) => $padding && `padding: ${$padding};`}
  ${({ $big }) =>
    $big &&
    `
    height: 50px;
    padding: 0 24px;

  `}

  ${({ $small, $paddingSmall }) =>
    $small &&
    `
    height: 32px;
    padding: 0 16px;
    font-size: 12px;
    min-width: 150px;
  ${$paddingSmall && `padding: ${$paddingSmall};`}

  `}

  ${({ $minWidthAuto }) => $minWidthAuto && 'min-width: auto;'}

  @media (max-width: 1200px) {
    min-width: 120px;

    ${({ $small }) =>
      $small &&
      `
    min-width: 100px;

  `}
    ${({ $minWidthAutoMD }) => $minWidthAutoMD && 'min-width: auto;'}
  }

  @media (max-width: 800px) {
    min-width: 120px;
    width: ${({ $widthSM }) => $widthSM && $widthSM};

    box-shadow: ${({ selected, theme }) =>
      selected ? theme.shadows.shadow2 : 'none'};

    ${({ $small }) =>
      $small &&
      `
    min-width: 100px;

  `}

    ${({ $smallSM, $paddingSmall }) =>
      $smallSM &&
      `
    height: 32px;
    padding: 0 16px;
    font-size: 12px;
    min-width: 150px;
  ${$paddingSmall && `padding: ${$paddingSmall};`}

  `}

    
    ${({ $minWidthAutoSM }) => $minWidthAutoSM && 'min-width: auto;'}
  }
`;

const TabsWrapperStyled = styled.div<{
  $big?: boolean;
  $minWidthAuto?: boolean;
  $minWidthAutoSM?: boolean;
}>`
  overflow-y: auto;
  display: flex;
  align-items: center;
  ::-webkit-scrollbar {
    display: none;
  }
  gap: 16px;
  padding: 32px 50px;
  margin: 0 -50px 0 -50px;

  @media (max-width: 800px) {
    gap: 12px;
    margin: 0 -16px 0 -16px;
    padding: 20px 16px 20px 16px;
  }
`;

/**
 * Accessible tab pattern (WAI-ARIA partial — see review item #24).
 *
 * `Tab` and `TabsWrapper` look identical to consumers (same props, same
 * visual output, same `selected` / `onClick` API) but now satisfy:
 *
 *   - `role="tablist"` on the container, `role="tab"` on each item
 *   - `aria-selected` reflects the `selected` prop, so screen readers
 *     announce "tab N, selected"
 *   - Every tab is reachable via the Tab key (`tabIndex=0`) — this is
 *     a deliberate departure from the WAI-ARIA "roving tabindex" pattern
 *     which only lets Tab land on the selected tab. The roving pattern
 *     surprises users who don't know to press arrow keys to discover
 *     the other tabs; keeping every tab tabbable is more discoverable
 *     and still accessible. Arrow keys remain as an enhancement.
 *   - Arrow keys ←/→ also move focus across tabs (manual activation —
 *     focus moves, user presses Enter/Space to activate).
 *   - Enter and Space activate the focused tab (handled here because
 *     the underlying element is still a div, not a `<button>`; this is
 *     the lowest-risk a11y upgrade for the 21 existing call sites).
 *
 * Not covered (would require migrating callers to a higher-level
 * `<Tabs>` + `<TabPanel>` API): `role="tabpanel"`, `aria-controls`
 * linkage, `aria-labelledby` from panel → tab. Tracked as future work.
 */

type TabStyleProps = ComponentProps<typeof TabStyled>;

type TabProps = TabStyleProps & {
  selected?: boolean;
  onClick?: () => void;
  children?: ReactNode;
};

export const Tab = ({
  selected,
  onClick,
  onKeyDown,
  children,
  ...rest
}: TabProps) => {
  const handleKeyDown = (event: ReactKeyboardEvent<HTMLDivElement>) => {
    // Forward to a caller's onKeyDown first (if any). If they call
    // preventDefault, we respect it.
    onKeyDown?.(event);
    if (event.defaultPrevented) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onClick?.();
    }
  };

  return (
    <TabStyled
      role="tab"
      aria-selected={!!selected}
      tabIndex={0}
      selected={selected}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      {...rest}
    >
      {children}
    </TabStyled>
  );
};

type TabsWrapperStyleProps = ComponentProps<typeof TabsWrapperStyled>;

export const TabsWrapper = ({
  children,
  onKeyDown,
  ...rest
}: TabsWrapperStyleProps & { children?: ReactNode }) => {
  const ref = useRef<HTMLDivElement>(null);

  const handleKeyDown = (event: ReactKeyboardEvent<HTMLDivElement>) => {
    onKeyDown?.(event);
    if (event.defaultPrevented) return;
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    const container = ref.current;
    if (!container) return;

    const tabs = Array.from(
      container.querySelectorAll<HTMLElement>('[role="tab"]')
    ).filter((el) => el.getAttribute('aria-disabled') !== 'true');
    if (tabs.length === 0) return;

    const currentIndex = tabs.indexOf(document.activeElement as HTMLElement);
    if (currentIndex === -1) return;

    event.preventDefault();
    const direction = event.key === 'ArrowRight' ? 1 : -1;
    const nextIndex = (currentIndex + direction + tabs.length) % tabs.length;
    tabs[nextIndex].focus();
  };

  return (
    <TabsWrapperStyled
      ref={ref}
      role="tablist"
      onKeyDown={handleKeyDown}
      {...rest}
    >
      {children}
    </TabsWrapperStyled>
  );
};

export const Pill = styled.div<{
  $background?: string;
  $shadow?: boolean;
  $pointer?: boolean;
  $padding?: string;
  $minWidth?: string;
  $minWidthSM?: string;
  $color?: string;
  $gap?: string;
  $height?: string;
  $border?: string;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: ${({ $height }) => $height || '24px'};
  min-width: ${({ $minWidth }) => $minWidth || '70px'};
  background: ${({ $background, theme }) =>
    $background ? $background : theme.primary};
  border-radius: 20px;
  padding: 2px 12px;
  ${({ $padding }) => $padding && `padding: ${$padding};`}
  box-shadow: ${({ $shadow, theme }) =>
    $shadow ? theme.shadows.shadow1 : 'none'};
  text-align: center;
  cursor: ${({ $pointer }) => $pointer && 'pointer'};
  gap: ${({ $gap }) => $gap && $gap};
  border: ${({ $border }) => $border && `1px solid ${$border}`};
  @media (max-width: 800px) {
    min-width: ${({ $minWidthSM }) => $minWidthSM || '50px'};
  }
`;

export const StatusCircle = styled.span<{
  $color: string | undefined | null;
}>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color};
  margin: 2px 0px 2px 0;
  display: inline-block;
`;

export const ProviderLogoWrapper = styled.div`
  width: 130px;
  height: 130px;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;

  span {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 105px;
    height: 105px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.white};
    box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.1);

    img {
      width: 70%;
      height: 70%;
      object-fit: contain;
    }
  }
`;

export const KeyValueInfo = ({
  k,
  v,
  separator = true,
  p,
}: {
  k: string;
  v: string | null;
  /** Skip the trailing rule - for the last row of a list. */
  separator?: boolean;
  /** Row padding override - trim the leading 16px on a list's first row. */
  p?: string;
}) => {
  return (
    <>
      <Div $p={p || '16px 0'}>
        <Disclaimer $mb="4">{k}</Disclaimer>
        <H5 $mb="0">{v}</H5>
      </Div>
      {separator && <Separator />}
    </>
  );
};

export const ProviderStatsGrid = styled.div`
  display: flex;
  gap: 24px;
  margin-bottom: 40px;
  overflow-x: auto;
  padding: 10px 50px 40px 50px;
  margin: 0 -50px 0 -50px;

  > div {
    min-width: 22%;
  }

  @media (max-width: 800px) {
    display: flex;
    gap: 20px;
    overflow-x: auto;
    padding: 10px 30px 40px 30px;
    margin: 0 -30px 0 -30px;

    > div {
      min-width: 70vw;
    }
  }

  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const StatusMark = styled.div<{
  $color?: string;
  $width?: string;
  $height?: string;
}>`
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
  height: ${({ $height }) => ($height ? $height : '32px')};
  width: ${({ $width }) => ($width ? $width : '6px')};
  border-radius: 0 10px 10px 0;
  ${({ $color }) => $color && `background: ${$color}`};
`;

/**
 * forwardRef so callers can attach refs (e.g. for roving-tabindex
 * keyboard nav inside listboxes — see AdminLocationsPicker /
 * AdminBrandsPicker). Without forwardRef, refs are silently dropped
 * because Box is a function component, not a styled component.
 */
export const Box = React.forwardRef<
  HTMLDivElement,
  React.ComponentProps<typeof Div>
>(({ children, ...props }, ref) => {
  return (
    <Div
      ref={ref as React.Ref<HTMLDivElement>}
      $p="12px 20px"
      $pSM="12px 16px"
      $box
      $minHeight="70px"
      $minHeightSM="60px"
      {...props}
    >
      {children}
    </Div>
  );
});
Box.displayName = 'Box';

export const modalVariants = {
  initial: {
    opacity: 0,
    transition: {
      type: 'ease',
      duration: 0.1,
    },
  },
  animate: {
    opacity: 1,
  },

  exit: {
    opacity: 0,
    transition: {
      type: 'ease',
      duration: 0.1,
    },
  },
};

export const HorizontalScroll = styled.div`
  display: flex;
  gap: 8px;
  scroll-snap-type: x mandatory;
  overflow-x: auto;
  flex-wrap: nowrap;

  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;

  @media (max-width: 800px) {
    padding: 10px 30px 40px 30px;
    margin: 0 -30px 0 -30px;
  }
`;

export const CreditCardStyled = styled.div`
  padding: 20px;
  background: ${({ theme }) => theme.blue};
  border-radius: 30px;
  border-radius: 24px;
  display: inline-flex;
  flex-direction: column;
  justify-content: space-between;
  flex: none;
  width: 100%;
  max-width: 400px;
  min-width: 400px;
  min-height: 235px;

  @media (max-width: 800px) {
    padding: 16px;
    max-width: 400px;
    min-width: auto;
    min-height: 200px;
  }
`;

const TruncatedTextStyled = styled.span<{
  $color?: string;
  $underline?: boolean;
}>`
  display: inline-block;
  /* width: 100%; Fill the container */
  max-width: 100%; /* Hard limit */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ $color, theme }) =>
    $color ? $color : theme.darkGray} !important;
  vertical-align: middle;
  ${({ $underline }) => $underline && `text-decoration: underline;`}
`;

export const TruncatedText = ({
  children,
  color,
  underline,
}: {
  children: any;
  color?: string;
  underline?: boolean;
}) => {
  return (
    <TruncatedTextStyled $color={color} $underline={underline}>
      {children}
    </TruncatedTextStyled>
  );
};
export const InfoComponentMobile = ({
  title,
  component,
  color,
}: {
  title?: string;
  component: React.ReactNode;
  color?: string;
}) => {
  return (
    <Div $flex $alignCenter $gap="4px" $width="100%">
      {title && (
        <Disclaimer
          $m="0"
          $color={color || lightTheme.darkGray}
          style={{ flex: 'none' }}
        >
          {title}:{' '}
        </Disclaimer>
      )}
      {component}
    </Div>
  );
};
